import React from 'react'

import { useHistory } from 'react-router-dom'

import { ZariContext } from '_zari/context'
import { Portlet, Table, Button, Form, Col, Row } from '_zari/core'

import { CodigosTransaccionesConstant, EstadosRequerimiento, TiposTablaPersonalizadaConstant } from 'constants/index'

import { DownloadAxiosFile, ZrSwal } from 'utils'

import * as RequerimientoService from 'services/requerimiento.service'
import * as UsuarioService from 'services/usuario.service'
import * as TablasPersonalizadasService from 'services/tablasPersonalizadas.service'

import TrazabilidadTimeline from 'sharedComponents/trazabilidad'

import * as Modals from './modals'
import PrevisualizarPdfModal from './modals/previsualizarpdf'

const portletBreadcrumbs = [{ name: 'Requerimientos' }]

const tableHeaderRows = [
  { label: 'GLOSA' },
  { label: 'FECHA EMISIÓN' },
  { label: 'CORRELATIVO' },
  { label: 'PRIORIDAD' },
  { label: 'ESTADO' },
  { label: 'OFICINA SOLIC.' },
  { label: 'USUARIO SOLIC.' },
  { label: '' }
]

const RequerimientosPage = () => {
  const __zariContext = React.useContext(ZariContext)
  const history = useHistory()
  const tablaRef = React.useRef(null)
  const idRequerimientoEditarEstadoRef = React.useRef('')
  const estadoActualEditarRef = React.useRef('')

  const [mostrarCambiarEstadoModal, setMostrarCambiarEstadoModal] = React.useState(false)
  const [mostrarVerDetalleModal, setMostrarVerDetalleModal] = React.useState(false)
  const idRequerimientoVerDetalleRef = React.useRef('')

  const [mostrarPdfModal, setMostrarPdfModal] = React.useState(false)
  const [pdfBlobUrl, setPdfBlobUrl] = React.useState('')

  const [mostrarTrazabilidadModal, setMostrarTrazabilidadModal] = React.useState(false)
  const idRequerimientoTrazabilidadRef = React.useRef('')

  const [esUsuarioGerencia, setEsUsuarioGerencia] = React.useState(false)
  const [esUsuarioJefeArea, setEsUsuarioJefeArea] = React.useState(false)
  const [esUsuarioLogistica, setEsUsuarioLogistica] = React.useState(false)
  const [vistaGerencia, setVistaGerencia] = React.useState(false)

  const clickVerTrazabilidad = React.useCallback(id => {
    idRequerimientoTrazabilidadRef.current = id
    setMostrarTrazabilidadModal(true)
  }, [])

  const [glosa, setGlosa] = React.useState('')
  const [fechaDesde, setFechaDesde] = React.useState('')
  const [fechaHasta, setFechaHasta] = React.useState('')
  const [idOficina, setIdOficina] = React.useState('')
  const [idUsuario, setIdUsuario] = React.useState('')

  const [oficinas, setOficinas] = React.useState([])
  const [usuarios, setUsuarios] = React.useState([])

  React.useEffect(() => {
    TablasPersonalizadasService.getAsSelect(TiposTablaPersonalizadaConstant.OFICINA)
      .then(({ data }) => setOficinas(data))
      .catch(() => {})

    UsuarioService.obtenerTodoAsSelect()
      .then(({ data }) => setUsuarios(data))
      .catch(() => {})

    UsuarioService.obtenerFlagsActual()
      .then(({ data }) => {
        setEsUsuarioGerencia(!!data.flagGerencia)
        setEsUsuarioJefeArea(!!data.esJefeDeAlgunaOficina)
        setEsUsuarioLogistica(!!data.flagLogistica)
      })
      .catch(() => {})
  }, [])

  const clickBuscar = () => {
    tablaRef.current.reload({
      glosa,
      fechaDesde,
      fechaHasta,
      idOficina,
      idUsuario,
      vistaGerencia: vistaGerencia ? '1' : ''
    })
  }

  const clickLimpiar = () => {
    setGlosa('')
    setFechaDesde('')
    setFechaHasta('')
    setIdOficina('')
    setIdUsuario('')
    tablaRef.current.reload({ vistaGerencia: vistaGerencia ? '1' : '' })
  }

  const clickToggleVistaGerencia = React.useCallback(() => {
    const nuevoValor = !vistaGerencia
    setVistaGerencia(nuevoValor)
    tablaRef.current.reload({
      glosa,
      fechaDesde,
      fechaHasta,
      idOficina,
      idUsuario,
      vistaGerencia: nuevoValor ? '1' : ''
    })
  }, [vistaGerencia, glosa, fechaDesde, fechaHasta, idOficina, idUsuario])

  const clickVerDetalle = React.useCallback(id => {
    idRequerimientoVerDetalleRef.current = id
    setMostrarVerDetalleModal(true)
  }, [])

  const clickNuevo = React.useCallback(() => {
    history.push(`/${CodigosTransaccionesConstant.REQUERIMIENTOS_NUEVOACTUALIZAR}`)
  }, [history])

  const clickEditar = React.useCallback(
    id => {
      history.push(`/${CodigosTransaccionesConstant.REQUERIMIENTOS_NUEVOACTUALIZAR}/${id}`)
    },
    [history]
  )

  const clickEditarEstado = React.useCallback((id, estadoActual) => {
    idRequerimientoEditarEstadoRef.current = id
    estadoActualEditarRef.current = estadoActual
    setMostrarCambiarEstadoModal(true)
  }, [])

  const clickEliminar = React.useCallback(
    id => {
      ZrSwal.showAlert({
        tipo: 'error',
        mensaje: 'Seguro que desea eliminar el registro?',
        showCerrar: true,
        onSuccess: () => {
          RequerimientoService.eliminarxId(id)
            .then(() => {
              __zariContext.snack('success', 'Registro eliminado')
              tablaRef.current.reload()
            })
            .catch(({ data: { error } }) => __zariContext.snack('error', error))
        }
      })
    },
    [__zariContext]
  )

  const clickDescargarPdf = React.useCallback(
    id => {
      __zariContext.loader.open('Cargando PDF de requerimiento.')

      RequerimientoService.descargarPdfA4xId(id)
        .then(({ data }) => {
          const url = URL.createObjectURL(new Blob([data], { type: 'application/pdf' }))
          setPdfBlobUrl(url)
          setMostrarPdfModal(true)
        })
        .catch(({ data: { error } }) => __zariContext.snack('error', error))
        .finally(() => {
          __zariContext.loader.close()
        })
    },
    [__zariContext]
  )

  const clickDescargarReporteConsolidado = React.useCallback(() => {
    if (!fechaDesde || !fechaHasta) {
      __zariContext.snack('warning', 'Seleccione fecha desde y hasta para descargar el reporte.')
      return
    }
    __zariContext.loader.open('Descargando reporte consolidado...')
    RequerimientoService.descargarReporteConsolidado({
      fechaDesde,
      fechaHasta,
      idOficina: idOficina || undefined,
      estado: undefined
    })
      .then(({ data, headers }) => {
        DownloadAxiosFile.downloadAsBlob(data, headers, 'ReporteConsolidadoRequerimientos.xlsx')
        __zariContext.snack('success', 'Reporte descargado.')
      })
      .catch(({ data: { error } }) => {
        __zariContext.snack('error', error || 'Error al descargar el reporte')
      })
      .finally(() => {
        __zariContext.loader.close()
      })
  }, [__zariContext, fechaDesde, fechaHasta, idOficina])

  const handleClosePdfModal = React.useCallback(() => {
    setMostrarPdfModal(false)
    if (pdfBlobUrl) {
      URL.revokeObjectURL(pdfBlobUrl)
      setPdfBlobUrl('')
    }
  }, [pdfBlobUrl])

  return (
    <>
      <Portlet>
        <Portlet.Header
          title='Requerimientos'
          breadcrumbs={portletBreadcrumbs}
          buttons={[{ name: 'Nuevo', onClick: clickNuevo }]}
        >
          {esUsuarioGerencia && (
            <Button
              size='sm'
              variant={vistaGerencia ? 'warning' : 'outline-secondary'}
              className='mr-2'
              onClick={clickToggleVistaGerencia}
            >
              {vistaGerencia ? 'Ver Todo' : 'Vista de Gerencia'}
            </Button>
          )}
        </Portlet.Header>
        <Portlet.Body>
          <Row className='p-3'>
            <Col md={3}>
              <Form.Group>
                <Form.Label text='GLOSA' htmlFor='filtro-glosa' md={4} />
                <Col md={8}>
                  <Form.InputText
                    id='filtro-glosa'
                    value={glosa}
                    onChange={e => setGlosa(e.target.value)}
                    placeholder='Buscar por glosa'
                  />
                </Col>
              </Form.Group>
            </Col>
            <Col md={2}>
              <Form.Group>
                <Form.Label text='DESDE' htmlFor='filtro-fecha-desde' md={5} />
                <Col md={7}>
                  <Form.InputDate
                    id='filtro-fecha-desde'
                    value={fechaDesde}
                    onChange={e => setFechaDesde(e.target.value)}
                  />
                </Col>
              </Form.Group>
            </Col>
            <Col md={2}>
              <Form.Group>
                <Form.Label text='HASTA' htmlFor='filtro-fecha-hasta' md={5} />
                <Col md={7}>
                  <Form.InputDate
                    id='filtro-fecha-hasta'
                    value={fechaHasta}
                    onChange={e => setFechaHasta(e.target.value)}
                  />
                </Col>
              </Form.Group>
            </Col>
            <Col md={2}>
              <Form.Group>
                <Form.Label text='OFICINA' htmlFor='filtro-oficina' md={5} />
                <Col md={7}>
                  <Form.Select id='filtro-oficina' value={idOficina} onChange={e => setIdOficina(e.target.value)}>
                    <option value=''>Todos</option>
                    {oficinas.map(o => (
                      <option key={o._id} value={o._id}>
                        {o.nombre}
                      </option>
                    ))}
                  </Form.Select>
                </Col>
              </Form.Group>
            </Col>
            <Col md={3}>
              <Form.Group>
                <Form.Label text='USUARIO' htmlFor='filtro-usuario' md={4} />
                <Col md={8}>
                  <Form.Select id='filtro-usuario' value={idUsuario} onChange={e => setIdUsuario(e.target.value)}>
                    <option value=''>Todos</option>
                    {usuarios.map(u => (
                      <option key={u._id} value={u._id}>
                        {u.username}
                      </option>
                    ))}
                  </Form.Select>
                </Col>
              </Form.Group>
            </Col>
          </Row>
          <Row className='px-3 pb-3'>
            <Col md={12} className='d-flex justify-content-end'>
              <Button variant='success' className='mr-2' onClick={clickDescargarReporteConsolidado}>
                <i className='fa fa-file-excel-o mr-1' />
                Reporte Consolidado
              </Button>
              <Button variant='secondary' className='mr-2' onClick={clickLimpiar}>
                Limpiar
              </Button>
              <Button onClick={clickBuscar}>Buscar</Button>
            </Col>
          </Row>
          <Table.ServerSide
            ref={tablaRef}
            useNest={true}
            url='/requerimientos'
            headRows={tableHeaderRows}
            rowTemplate={row => (
              <Table.Row key={row._id}>
                <Table.Cell>{row.glosa || '--'}</Table.Cell>
                <Table.Cell>{row.fechaEmision || '--'}</Table.Cell>
                <Table.Cell>{row.correlativo || '--'}</Table.Cell>
                <Table.Cell>{row.prioridad || 'NORMAL'}</Table.Cell>
                <Table.Cell>
                  {row.estado && EstadosRequerimiento.__dictionary[row.estado] ? (
                    <span
                      className={`badge badge-${EstadosRequerimiento.__dictionary[row.estado].color || 'secondary'}`}
                      style={{
                        cursor: ![
                          EstadosRequerimiento.CERRADO,
                          EstadosRequerimiento.RECHAZADO,
                          EstadosRequerimiento.ANULADO
                        ].includes(row.estado)
                          ? 'pointer'
                          : 'default'
                      }}
                      onClick={() => {
                        if (
                          ![
                            EstadosRequerimiento.CERRADO,
                            EstadosRequerimiento.RECHAZADO,
                            EstadosRequerimiento.ANULADO
                          ].includes(row.estado)
                        ) {
                          clickEditarEstado(row._id, row.estado)
                        }
                      }}
                    >
                      {EstadosRequerimiento.__dictionary[row.estado].nombre}
                    </span>
                  ) : (
                    '--'
                  )}
                </Table.Cell>
                <Table.Cell>{row.oficinaSolicitante || '--'}</Table.Cell>
                <Table.Cell title={row.nombreCompletoUsuario || ''}>
                  {row.nombreCompletoUsuario || row.usuario || '--'}
                </Table.Cell>
                <Table.Cell>
                  <div className='d-flex align-items-center'>
                    <Button
                      size='sm'
                      variant='outline-info'
                      className='mr-1'
                      title='Ver Detalle'
                      onClick={() => clickVerDetalle(row._id)}
                    >
                      <i className='fa fa-eye' />
                    </Button>
                    <Button
                      size='sm'
                      variant='outline-secondary'
                      className='mr-1'
                      title='Ver Trazabilidad'
                      onClick={() => clickVerTrazabilidad(row._id)}
                    >
                      <i className='fa fa-history' />
                    </Button>
                    <Button
                      size='sm'
                      variant='outline-primary'
                      className='mr-1'
                      title='Descargar PDF'
                      onClick={() => clickDescargarPdf(row._id)}
                    >
                      <i className='fa fa-file-pdf' />
                    </Button>
                  </div>
                </Table.Cell>
              </Table.Row>
            )}
          />
        </Portlet.Body>
      </Portlet>
      {mostrarCambiarEstadoModal && (
        <Modals.CambiarEstadoModal
          show={mostrarCambiarEstadoModal}
          handleClose={() => setMostrarCambiarEstadoModal(false)}
          idRequerimiento={idRequerimientoEditarEstadoRef.current}
          estadoActual={estadoActualEditarRef.current}
          reloadTable={tablaRef.current.reload}
        />
      )}
      {mostrarVerDetalleModal && (
        <Modals.VerDetalleModal
          show={mostrarVerDetalleModal}
          handleClose={() => setMostrarVerDetalleModal(false)}
          idRequerimiento={idRequerimientoVerDetalleRef.current}
        />
      )}
      {mostrarPdfModal && (
        <PrevisualizarPdfModal show={mostrarPdfModal} handleClose={handleClosePdfModal} pdfBlobUrl={pdfBlobUrl} />
      )}
      {mostrarTrazabilidadModal && (
        <Modals.TrazabilidadModal
          show={mostrarTrazabilidadModal}
          handleClose={() => setMostrarTrazabilidadModal(false)}
          idRequerimiento={idRequerimientoTrazabilidadRef.current}
        />
      )}
    </>
  )
}

export default React.memo(RequerimientosPage)
